import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import { rundownActions } from "../imports";
import { cuesApi } from "../imports";
import Cue, { IconXYZ, IconT, IconContent, IconTrigger, IconCrop, GroupCue } from "./Cue";
import { H2RButton } from "../imports";
import { H2RInput } from "../imports";
import { H2RSelect } from "../imports";
import { Sidebar } from "../imports";
import { H2RHeading } from "../imports";
import { useIsPro } from "../imports";
import ProBadge from "./snippets/ProBadge";
import NewCueButton from "./NewCueButton";

import { definitions, imageTypesDefinitions } from "../templates/cues";

import CueEditContentWrapper from "../CueEditContentWrapper";
import CueEditOffsetWrapper from "../CueEditOffsetWrapper";
import CueEditThemeWrapper from "../CueEditThemeWrapper";
import CueEditCropWrapper from "../CueEditCropWrapper";
import ProjectName from "./ProjectName";
import { faCircleChevronRight, faClose, faLock, faLockOpen, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function RundownInternals({
	selectedProject = {},
	cueToEdit = null,
	cues = [],
	cloud = false,
	addingGraphic = false,
	setAddingGraphic = null,
	defaultThemeId = "",
	order = [],
	projectName = "",
}) {
	let { projectId } = useParams();

	console.log(order)

	const [runCues, setRunCues] = useState([]);
	const [addingGraphicTab] = useState("simple");
	const [addingGraphicFilter, setAddingGraphicFilter] = useState("");
	const [filterCuesSearch, setFilterCuesSearch] = useState("");
	const [outputsFiltered, setOutputsFiltered] = useState([])
	const isPro = useIsPro();

	const locked = useSelector((state) => state.rundown?.locked);
	const cueEditing = useSelector((state) => state.rundown?.editing);

	const addGraphicSearchRef = useRef();

	const filteredCues = cues
	// const filteredCues = useMemo(() => {
  //   let isSectionHidden = false;

  //   return cues.filter(cue => {
  //     if (cue.type === 'section') {
  //       // Update the current state based on the 'hidden' property of the section
  //       isSectionHidden = cue.hidden || false;
  //       return true; // Always include 'section' cues
  //     }
  //     if (cue.type !== 'section') {
  //       // Include 'lower_third' only if the current section is not hidden
  //       return !isSectionHidden;
  //     }
  //     // Optionally include other types if needed
  //     return true;
  //   });
  // }, [cues]); // Dependency array ensures memoization based on the `cues` array

	const onDragEnd = (result) => {
		const { destination, source, draggableId } = result;

		console.log(destination, source, draggableId)

		// if (result.combine) {
		// 	// CANCEL IF IT IS A GROUP CUE
		// 	// CANCEL IF DESTINATION IS NOT A GROUP CUE

		// 	console.log(result, result.combine);
		// 	// cuesApi.reorderCue(
		// 	// 	projectId,
		// 	// 	draggableId,
		// 	// 	source.index,
		// 	// 	selectedProject.cues?.findIndex(
		// 	// 		(c) => c.id === result.combine.draggableId
		// 	// 	) + 1
		// 	// );

		// 	// cuesApi.updateCue(draggableId, projectId, {
		// 	// 	partOfGroup: result.combine?.draggableId,
		// 	// });
		// }

		if (!destination) return null;

		if (
			destination.droppableId === source.droppableId &&
			destination.index === source.index
		)
			return null;

		// mainActions.reorderCues(
		// 	projectId,
		// 	draggableId,
		// 	source.index,
		// 	destination.index
		// );
		cuesApi.reorderCue(
			projectId,
			draggableId,
			source.index,
			destination.index,
		);
	};

	const fileUpload = async (file) => {
		const formData = new FormData();
		formData.append("file", file);

		const { data } = await cuesApi.importFile(projectId, formData);

		await console.log("awaited id", data);

		// CHECK IF IMAGE AND PROCEED
		if (!imageTypesDefinitions.includes(data.fileData.mimetype)) return null;

		await cuesApi.addCue(
			"image",
			projectId,
			{
				name: data?.fileData?.originalname || "Imported image",
				filename: data?.fileData?.filename,
			},
			false,
			defaultThemeId
		);
	};

	const dropHandler = (ev) => {
		console.log("File(s) dropped");

		// Prevent default behavior (Prevent file from being opened)
		ev.preventDefault();

		if (ev.dataTransfer.items) {
			// Use DataTransferItemList interface to access the file(s)
			[...ev.dataTransfer.items].forEach((item, i) => {
				// If dropped items aren't files, reject them
				if (item.kind === "file") {
					const file = item.getAsFile();
					fileUpload(file);
					console.log(`… file[${i}].name = ${file.name}`);
				}
			});
		} else {
			// Use DataTransfer interface to access the file(s)
			[...ev.dataTransfer.files].forEach((file, i) => {
				console.log(`… file[${i}].name = ${file.name}`);
				fileUpload(file);
			});
		}
	};
	
	const showHideOutput = (output) =>{
		console.log(output)
		if(outputsFiltered.includes(output)){
			setOutputsFiltered([])
		}  else {
			setOutputsFiltered([output])
		}
	}

	useEffect(() => {
		if (addingGraphic) {
			setTimeout(() => {
				addGraphicSearchRef.current?.focus();
				addGraphicSearchRef.current?.select();
			}, [250]);
		}
	}, [addingGraphic]);

	useEffect(() => {
		if (selectedProject && cues) {
			setRunCues(
				cues.filter((cue) => {
					if (cue.status === "cued" || cue.status === "cuedoff") return true;
				})
			);
		}
	}, [cues]);

	if (selectedProject === undefined) {
		return null;
	} else {
		return (
			<>
				<section
					onDrop={dropHandler}
					onDragOver={(e) => {
						e.preventDefault();
						console.log("dragging over");
					}}
					className={`mx-4 my-2 flex flex-col flex-1 justify-between overflow-y-auto`}
				>
					<div className="flex justify-between items-center mb-1 mt-1">
						<ProjectName
							name={selectedProject.name || projectName}
							size="h5"
							selectedProject={projectId}
						/>
						<div className="flex space-x-2 mr-1">
							{!addingGraphic ? (
								<H2RButton
									title="Add new graphic"
									icon={faPlus}
									colour="dark"
									size="small"
									text="Add"
									css="w-min whitespace-pre"
									onClick={() => {
										if (cueToEdit !== null) {
											rundownActions.cueToEdit(null, false);
										}
										return setAddingGraphic(true);
									}}
								/>
							) : (
								<H2RButton
									title="Cancel adding graphic"
									icon={faClose}
									colour="dark"
									text="Add"
									size="small"
									css="w-min whitespace-pre"
									onClick={() => setAddingGraphic(false)}
								/>
							)}
							<H2RButton
								title={
									locked
										? "Unlock to edit graphics"
										: "Lock to avoid editing graphics"
								}
								text={locked ? "Edit" : "Lock"}
								icon={locked ? faLockOpen : faLock}
								size="small"
								colour="dark"
								css={`w-min`}
								onClick={() => {
									if (cueToEdit !== null) {
										rundownActions.cueToEdit(null, false);
									}
									return rundownActions.rundownLock(!locked);
								}}
							/>
							{runCues.length > 0 && (
								<H2RButton
									title="Show/hide cued graphics"
									text="Run"
									disabled={runCues.length <= 0}
									size="small"
									colour="main"
									icon={faCircleChevronRight}
									css={`w-min`}
									onClick={() => {
										return cuesApi.runCues(projectId, runCues);
									}}
								/>
							)}
						</div>
					</div>
					<div className="flex items-start w-full">
						{filterCuesSearch && (
							<button
								className="mr-2 ml-1 focus:outline-none focus:ring rounded-full"
								onClick={() => setFilterCuesSearch("")}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									strokeWidth="1"
									stroke="currentColor"
									className="w-6 h-6 text-gray-500"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
							</button>
						)}
						<input
							value={filterCuesSearch}
							onChange={(e) => {
								setFilterCuesSearch(e.target.value);
							}}
							className="mb-1 py-0.5 w-full bg-gray-900 text-sm border-b border-gray-900 text-gray-500 placeholder-gray-600 focus:outline-none focus:border-gray-500 ring-main-500 hover:border-gray-700"
							placeholder="Filter by type or content..."
						/>
						{isPro && 
						
						<div className="ml-1 mt-auto flex gap-1 text-xs">
							<button
							title="Filter by Output 1"
							onClick={()=>{showHideOutput('outputOne')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputsFiltered.includes('outputOne')? 'bg-red-500': 'bg-transparent hover:bg-gray-800 text-gray-500'
							].join(' ')}>1</button>
							<button
							title="Filter by Output 2"
							onClick={()=>{showHideOutput('outputTwo')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputsFiltered.includes('outputTwo') ? 'bg-red-500': 'bg-transparent hover:bg-gray-800 text-gray-500'
							].join(' ')}>2</button>
							<button
							title="Filter by Output 3"
							onClick={()=>{showHideOutput('outputThree')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputsFiltered.includes('outputThree') ? 'bg-red-500': 'bg-transparent hover:bg-gray-800 text-gray-500'
							].join(' ')}>3</button>
							<button
							title="Filter by Output 4"
							onClick={()=>{showHideOutput('outputFour')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputsFiltered.includes('outputFour') ? 'bg-red-500': 'bg-transparent hover:bg-gray-800 text-gray-500'
							].join(' ')}>4</button>
							<button
							title="Filter by Utility Output"
							onClick={()=>{showHideOutput('outputUtility')}}
							className={[
								'px-1 rounded-sm mr-2',
								outputsFiltered.includes('outputUtility') ? 'bg-red-500': 'bg-transparent hover:bg-gray-800 text-gray-500'
							].join(' ')}>U</button>
						</div>

						}
					</div>
					<div className="flex-grow" style={{ overflow: "auto" }}>
						<span className="pl-0 flex text-gray-700 rounded font-semibold text-xxs ">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="none"
							>
								<path
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.5"
									d="M6 13.5v-3A3.5 3.5 0 0 1 9.5 7h2.75"
								/>
							</svg>
							<span className="pl-2 uppercase">Back</span>
						</span>
						<DragDropContext
							onDragEnd={(result) => {
								onDragEnd(result);
							}}
						>
							<Droppable
								droppableId="cuelist"
								// isCombineEnabled={true}
							>
								{(provided) => (
									<div
										className="min-w-max"
										ref={provided.innerRef}
										{...provided.droppableProps}
									>
										{cues
											?.slice()
											?.sort((a, b) => {
												const aIndex = order.indexOf(a.id);
												const bIndex = order.indexOf(b.id);
												return aIndex - bIndex;
											})
											.map((cue, index) => {
												if (
													!String([
														cue?.type?.toUpperCase(),
														cue?.line_one?.toUpperCase(),
														cue?.line_two?.toUpperCase(),
														cue?.body?.toUpperCase(),
														cue?.name?.toUpperCase(),
														cue?.title?.toUpperCase(),
														cue?.label?.toUpperCase(),
														cue?.id?.toUpperCase(),
													]).includes(filterCuesSearch?.toUpperCase())
												)
													return null;

													if(outputsFiltered.includes('outputOne') && cue.outputOne === false) return null
													if(outputsFiltered.includes('outputTwo') && cue.outputTwo !== true) return null
													if(outputsFiltered.includes('outputThree') && cue.outputThree !== true) return null
													if(outputsFiltered.includes('outputFour') && cue.outputFour !== true) return null
													if(outputsFiltered.includes('outputUtility') && cue.outputUtility !== true) return null
												return (
													<Cue
														key={cue.id}
														cue={cue}
														cues={cues}
														index={index}
														hidden={cue.type !== 'section' && !filteredCues.includes(cue)}
														clickable={cue.type === "section" ? false : true}
														cueToEdit={cueToEdit}
														cloud={cloud}
														order={order}
														defaultThemeId={defaultThemeId}
														onCueEdit={(cue) => {
															if (addingGraphic) {
																setAddingGraphic(false);
															}
															rundownActions.cueToEdit(null, false);
															setTimeout(() => {
																rundownActions.rundownLock(false);
																rundownActions.cueToEdit(cue, true);
															}, 200);
														}}
													/>
												);
											})}
										{provided.placeholder}
									</div>
								)}
							</Droppable>
						</DragDropContext>
						<span className="pl-0 flex text-gray-700 rounded font-semibold text-xxs ">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="none"
							>
								<path
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.5"
									d="M6 2v2.768c0 .857.354 1.68.984 2.285a3.43 3.43 0 0 0 2.376.946L12 8"
								/>
							</svg>
							<span className="pl-2 uppercase">Front</span>
						</span>
					</div>
				</section>

				<Sidebar
					title={definitions[cueToEdit?.type]?.name || ""}
					type={cueToEdit?.type}
					subtitle={cueToEdit ? `ID: ${cueToEdit.id}` : ""}
					open={cueEditing && !addingGraphic}
					onDone={() => {
						return rundownActions.cueToEdit(null, false);
					}}
				>
					{cueToEdit && (
						<CueEditForm
							cueToEdit={cueToEdit}
							cues={cues}
							onCueEditDone={() => {
								rundownActions.cueToEdit(null, false);
							}}
						/>
					)}
				</Sidebar>

				<Sidebar
					title={`Add graphic`}
					open={addingGraphic}
					onDone={() => {
						return setAddingGraphic(false);
					}}
				>
					<div className="flex mb-2 w-100 space-x-2 justify-center py-2">
						<input
							ref={addGraphicSearchRef}
							type="text"
							className="px-2 py-0.5 w-full bg-gray-900 rounded focus:outline-none focus:ring ring-main-500"
							placeholder="Filter..."
							value={addingGraphicFilter}
							onChange={(e) => {
								setAddingGraphicFilter(e.target.value);
							}}
						/>
						{addingGraphicFilter && (
							<H2RButton
								icon={faClose}
								size="small"
								colour="dark"
								disabled={!addingGraphicFilter}
								onClick={() => setAddingGraphicFilter("")}
							/>
						)}
					</div>
					{addingGraphicTab === "simple" && (
						<div className="space-y-2 w-88">
							{Object.entries(definitions)
								.sort(([a, aa], [b, bb]) => {
									if (isPro) return null;
									if (bb.pro) {
										return -1;
									} else {
										return 1;
									}
								})
								.filter(([name, cue]) =>
									cue.name
										.toUpperCase()
										.includes(addingGraphicFilter.toUpperCase())
								)
								.filter(([name, cue]) => !cue.hidden)
								.map(([name, cue]) => {
									return (
										<NewCueButton
											key={cue.name}
											buttonClicked={() => setAddingGraphic(false)}
											projectId={projectId}
											text={cue.name}
											cueType={name}
											pro={cue.pro}
											defaultThemeId={defaultThemeId}
										/>
									);
								})}
						</div>
					)}
				</Sidebar>
			</>
		);
	}
}

const CueEditForm = ({ cueToEdit, cues, onCueEditDone }) => {
	const { projectId } = useParams();
	const [showContent, setShowContent] = useState(true);
	const [showPosition, setShowPosition] = useState(false);
	const [showTheme, setShowTheme] = useState(false);
	const [showTriggers, setShowTriggers] = useState(false);
	const [showCrop, setShowCrop] = useState(false);

	const cue = cues?.filter((c) => c.id === cueToEdit.id)[0];

	if (cue === undefined || cue === null) {
		return "...";
	}

	return (
		<div className="flex flex-col justify-between h-full">
			<div className="px-2 py-2 flex-grow overflow-auto">
				<input
					value={cue.label}
					className="w-full bg-transparent hover:underline text-xs text-gray-500 focus:outline-none focus:ring focus:ring-main-500 focus:no-underline rounded-sm"
					placeholder="Add custom label"
					onChange={(e) => {
						cuesApi.updateCue(cue.id, projectId, {
							label: e.target.value,
						});
					}}
				/>
				{/* <input
					value={cue.keyboardShortcut}
					className="w-full bg-transparent hover:underline text-xs text-gray-500 focus:outline-none focus:ring focus:ring-main-500 focus:no-underline rounded-sm"
					placeholder="Keyboard shortcut"
					onChange={(e) => {
						cuesApi.updateCue(cue.id, projectId, {
							keyboardShortcut: e.target.value,
						});
					}}
				/> */}
				<div className="mt-2 flex flex-col space-y-2">
					<ColapsableHeader
						text="Content"
						onClick={() => {
							setShowContent(!showContent);
							setShowTheme(false);
							setShowPosition(false);
							setShowCrop(false);
							setShowTriggers(false);
						}}
						opened={showContent}
					/>
					{showContent && <CueEditContentWrapper cue={cue} />}
					<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
					{cue.type !== "section" && (
						<>
							<ColapsableHeader
								text="Theme"
								onClick={() => {
									setShowContent(false);
									setShowTheme(!showTheme);
									setShowPosition(false);
									setShowCrop(false);
									setShowTriggers(false);
								}}
								opened={showTheme}
								editable={definitions[cue.type].theme}
							/>

							{showTheme && <CueEditThemeWrapper cue={cue} />}
							<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
							<ColapsableHeader
								text="Position"
								onClick={() => {
									setShowContent(false);
									setShowTheme(false);
									setShowPosition(!showPosition);
									setShowCrop(false);
									setShowTriggers(false);
								}}
								opened={showPosition}
								editable={definitions[cue.type].position}
							/>
							{showPosition && <CueEditOffsetWrapper cue={cue} />}
							<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
							<ColapsableHeader
								text="Crop"
								onClick={() => {
									setShowContent(false);
									setShowTheme(false);
									setShowPosition(false);
									setShowCrop(!showCrop);
									setShowTriggers(false);
								}}
								opened={showCrop}
								editable={definitions[cue.type].crop}
							/>
							{showCrop && <CueEditCropWrapper cue={cue} />}
							<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
							<ColapsableHeader
								text="Triggers"
								onClick={() => {
									setShowContent(false);
									setShowTheme(false);
									setShowPosition(false);
									setShowCrop(false);
									setShowTriggers(!showTriggers);
								}}
								opened={showTriggers}
								editable={definitions[cue.type].triggers}
							/>
							{showTriggers && <TriggerOptions cue={cue} />}
							<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
						</>
					)}
					{cue.type !== "section" && <OutputOptions cue={cue} />}
				</div>
			</div>
		</div>
	);
};

const ColapsableHeader = ({ text = "", onClick, opened, editable = true }) => {
	let icon;

	switch (text) {
		case "Content":
			icon = <IconContent opacity="100" />;
			break;

		case "Theme":
			icon = <IconT opacity="100" />;
			break;

		case "Position":
			icon = <IconXYZ opacity="100" />;
			break;

		case "Triggers":
			icon = <IconTrigger opacity="100" />;
			break;

		case "Crop":
			icon = <IconCrop opacity="100" />;
			break;

		default:
			break;
	}

	return (
		<button
			className={`py-3 flex justify-between items-center focus:outline-none
						${editable ? "cursor-pointer" : "cursor-default opacity-50"}
			`}
			onClick={() => {
				if (!editable) return null;
				onClick();
			}}
			// disabled={editable}
		>
			<div className="flex justify-center items-center">
				<span className="pr-2">{icon}</span>
				<H2RHeading type="h6">{text}</H2RHeading>
			</div>
			<div
				className={`flex items-center justify-center text-gray-500
						${opened && "transform -rotate-90"}
			`}
			>
				<svg className="w-4 h-4" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M10 12.667L5.333 8 10 3.333"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</div>
		</button>
	);
};

const TriggerOptions = ({ cue }) => {
	let { projectId } = useParams();

	let isPro = useIsPro();

	const cues = useSelector((state) => state.main.projects?.[projectId]?.cues);
	return (
		<>
			<H2RInput
				placeholder="∞"
				value={cue.onAirDuration}
				label="Duration (seconds)"
				type="number"
				min="1"
				max="100"
				onChange={(change) => {
					return cuesApi.updateCue(cue.id, projectId, {
						onAirDuration: change,
					});
				}}
			/>
			<div className="flex justify-center items-end">
				<H2RSelect
					selected={cue.linkedTo}
					label={`Link to graphic `}
					disabled={!isPro}
					options={[
						{
							label: "None",
							value: "none",
						},
						...cues
							.filter((c) => {
								if (c.id === cue.id) {
									return false;
								} else if (c.type === "section") {
									return false;
								} else if (c.linkedTo === cue.id) {
									return false;
								} else {
									return true;
								}
							})
							.map((c) => {
								return {
									label: `${definitions?.[c.type]?.name} (${c.id})`,
									value: c.id,
								};
							}),
					]}
					onChange={(value) => {
						return cuesApi.updateCue(cue.id, projectId, {
							linkedTo: value,
						});
					}}
				/>
				<div>
					<ProBadge />
				</div>
			</div>

			{cue.linkedTo && (
				<H2RInput
					placeholder="0"
					value={cue.linkedDelay || 0}
					label="Linked delay (milliseconds)"
					type="number"
					min="0"
					max="1000"
					onChange={(change) => {
						if (change < 0) return null;
						return cuesApi.updateCue(cue.id, projectId, {
							linkedDelay: change,
						});
					}}
				/>
			)}
		</>
	);
};

const OutputOptions = ({ cue }) => {
	let { projectId } = useParams();
	let isPro = useIsPro();

	return (
		<>
			<span className="text-sm font-semibold text-gray-500">
				Show on Outputs <ProBadge />{" "}
			</span>
			<div>
				<button
					type="button"
					onClick={() => {
						cuesApi.updateCue(cue.id, projectId, {
							outputOne: cue.outputOne === undefined ? false : !cue.outputOne,
						});
					}}
					className={`px-4 py-2 focus:outline-none rounded-l transition duration-300
                    ${
											cue.outputOne || cue.outputOne === undefined
												? "bg-red-600 hover:bg-red-500"
												: "bg-gray-700 hover:bg-gray-600"
										}
									
    `}
				>
					1
				</button>
				<button
					type="button"
					disabled={!isPro}
					onClick={() => {
						cuesApi.updateCue(cue.id, projectId, {
							outputTwo: !cue.outputTwo ? true : !cue.outputTwo,
						});
					}}
					className={`px-4 py-2 focus:outline-none transition duration-300
					${!isPro && "opacity-10 cursor-default"}
                    ${
											cue.outputTwo
												? "bg-red-600 hover:bg-red-500"
												: "bg-gray-700 hover:bg-gray-600"
										}
    `}
				>
					2
				</button>
				<button
					type="button"
					disabled={!isPro}
					onClick={() => {
						cuesApi.updateCue(cue.id, projectId, {
							outputThree: !cue.outputThree ? true : !cue.outputThree,
						});
					}}
					className={`px-4 py-2 focus:outline-none transition duration-300
					${!isPro && "opacity-10 cursor-default"}
                    ${
											cue.outputThree
												? "bg-red-600 hover:bg-red-500"
												: "bg-gray-700 hover:bg-gray-600"
										}
    `}
				>
					3
				</button>
				<button
					type="button"
					disabled={!isPro}
					onClick={() => {
						cuesApi.updateCue(cue.id, projectId, {
							outputFour: !cue.outputFour ? true : !cue.outputFour,
						});
					}}
					className={`px-4 py-2 focus:outline-none transition duration-300
					${!isPro && "opacity-10 cursor-default"}
                    ${
											cue.outputFour
												? "bg-red-600 hover:bg-red-500"
												: "bg-gray-700 hover:bg-gray-600"
										}
    `}
				>
					4
				</button>
				<button
					type="button"
					disabled={!isPro}
					onClick={() => {
						cuesApi.updateCue(cue.id, projectId, {
							outputUtility: !cue.outputUtility ? true : !cue.outputUtility,
						});
					}}
					className={`px-4 py-2 focus:outline-none transition duration-300 rounded-r
					${!isPro && "opacity-10 cursor-default"}
                    ${
											cue.outputUtility
												? "bg-red-600 hover:bg-red-500"
												: "bg-gray-700 hover:bg-gray-600"
										}
    `}
				>
					Utility
				</button>
			</div>
		</>
	);
};
